var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"c-Chip",class:_vm.chipClassObject,on:{"click":_vm.emitClick}},[_vm._t("leading"),_c('span',{staticClass:"c-Chip__value"},[_vm._v(_vm._s(_vm.value))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }